import React, { useState, forwardRef, useRef } from "react";
import {
    EonUiRadioButtonGroup,
} from "@eon-ui/eon-ui-components-react";
import "./SourceSelector.scss";
import { useTranslation } from "@me8eon/translation";
import { ItemComponent } from "./components/Item.component";
import { IconButtonComponent } from "./components/IconButton.component";
import { HeaderComponent } from "./components/Header.component";
import { SimpleOutsideClick } from "@me8eon/outside_click";

type Source = {
    id: string;
    name: string;
    description: string;
}

export interface SourceSelectorProps {
    iconLabel?: string;
    sources: Source[]
    selectedSource: string;
    setSelectedSource: (source: string | undefined) => void;
    top?: boolean;
}


export const SourceSelector = forwardRef<HTMLDivElement, SourceSelectorProps>(({
    sources,
    selectedSource,
    setSelectedSource,
    iconLabel,
    top,

}, ref) => {
    const t = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const close = () => {
        setIsOpen(false);
    }

    return (
        <SimpleOutsideClick onClickOutside={close}>
            <div className="source-selector" ref={ref}>
                <IconButtonComponent active={isOpen || !!selectedSource}
                    label={iconLabel}
                    icon={"source"}
                    onClick={(_e) => setIsOpen(!isOpen)}
                />
                {isOpen && (
                    <div
                        className={`source-selector__dropdown source-selector__dropdown${!top ? "--top" : "--bottom"}`}>
                        <HeaderComponent title={t("sourceSelector.title")} close={close} />
                        <div className="source-selector__dropdown-options">
                            <EonUiRadioButtonGroup
                                scheme="neutral800"
                                name="source-selector"
                                value={selectedSource}
                                onValueChanged={(e) => {
                                    setSelectedSource(e.target.value);
                                    close();
                                }}
                            >
                                {sources.map(source =>
                                    <ItemComponent value={source.id}
                                        title={source.name}
                                        description={source.description}
                                        key={source.id} />
                                )}
                            </EonUiRadioButtonGroup>
                        </div>
                    </div>
                )}
            </div>
        </SimpleOutsideClick>
    );
});
